import React from "react";
import Home from "./components/home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GitHubUserInfo from "./components/GitHubUserInfo";
import GitRepo from "./components/GitRepo";
import Navbar from "./components/NavBar";
import { useDispatch } from "react-redux";
import { setLoggedIn, setLoggedOut } from "./redux/auth/auth.actions";
import GitHubCallback from "./components/GitHubCallback";
import ProtectedRoute from "./components/utils/protectedRoutes";

function App() {
  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setLoggedIn());
  };

  const handleLogout = () => {
    dispatch(setLoggedOut());
  };

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/github/callback" element={<GitHubCallback />} /> */}
        <Route element={<ProtectedRoute />}>
          <Route path="/UserInfo" element={<GitHubUserInfo />} />
          <Route path="/:username/:name" element={<GitRepo />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;